import React, { createContext, useContext, useState } from 'react';

// Create the context
const EnvironmentContext = createContext();

// Hook for easy access
export const useEnvironment = () => useContext(EnvironmentContext);

// Provider component
export const EnvironmentProvider = ({ children }) => {
  const [env, setEnv] = useState(() => {
    // Load from localStorage or default to 'memo'
    return localStorage.getItem('env') || 'memo';
  });

  const updateEnv = (newEnv) => {
    setEnv(newEnv);
    localStorage.setItem('env', newEnv);
  };

  return (
    <EnvironmentContext.Provider value={{ env, setEnv: updateEnv }}>
      {children}
    </EnvironmentContext.Provider>
  );
};
